module.exports = __webpack_public_path__ + "media/images/minus-5d8c730ee5a82acc1445378cd5caa679.svg";